import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import apiService from '../services/ApiService';

export default function SuggestTopicSection() {
  const { t } = useTranslation();
  const [topic, setTopic] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [feedback, setFeedback] = useState(null); // { type: 'success'|'error', message }

  const handleSubmit = async () => {
    const trimmed = topic.trim();
    if (!trimmed) return;
    setSubmitting(true);
    setFeedback(null);
    try {
      await apiService.post('/api/v1/suggestions', { topic: trimmed });
      setTopic('');
      setFeedback({ type: 'success', message: t('suggestions.submitSuccess') });
    } catch (err) {
      setFeedback({ type: 'error', message: err.message || t('common.error') });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Card sx={{ width: '100%' }}>
      <CardContent>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
          <LightbulbIcon color="warning" fontSize="small" />
          <Typography variant="subtitle1" fontWeight={600}>
            {t('suggestions.title')}
          </Typography>
        </Box>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          {t('suggestions.description')}
        </Typography>

        <Box sx={{ display: 'flex', gap: 2, alignItems: 'flex-start', flexWrap: 'wrap' }}>
          <TextField
            size="small"
            value={topic}
            onChange={(e) => setTopic(e.target.value)}
            placeholder={t('suggestions.placeholder')}
            inputProps={{ maxLength: 100 }}
            sx={{ flex: 1, minWidth: 200 }}
            onKeyDown={(e) => { if (e.key === 'Enter') handleSubmit(); }}
            disabled={submitting}
          />
          <Button
            variant="outlined"
            color="warning"
            onClick={handleSubmit}
            disabled={submitting || !topic.trim()}
          >
            {t('suggestions.submitButton')}
          </Button>
        </Box>

        {feedback && (
          <Typography
            variant="body2"
            color={feedback.type === 'success' ? 'success.main' : 'error.main'}
            sx={{ mt: 1.5 }}
          >
            {feedback.message}
          </Typography>
        )}
      </CardContent>
    </Card>
  );
}
